module.exports = __webpack_public_path__ + "img/0546d0d957de80c67c849edc3251bdbc.32cc2b43.png";